export const ctaOptions = [
  { text: "Download", id: "DOWNLOAD" },
  { text: "Get offer", id: "GET_OFFER" },
  { text: "Get quote", id: "GET_QUOTE" },
  { text: "Get showtimes", id: "GET_SHOWTIMES" },
  { text: "Learn more", id: "LEARN_MORE" },
  { text: "Listen now", id: "LISTEN_NOW" },
  { text: "Order now", id: "ORDER_NOW" },
  { text: "Play game", id: "PLAY_GAME" },
  { text: "Request time", id: "REQUEST_TIME" },
  { text: "See menu", id: "NO_BUTTON" },
  { text: "Shop now", id: "SHOP_NOW" },
  { text: "Sign up", id: "SIGN_UP" },
  { text: "Subscribe", id: "SUBSCRIBE" },
  { text: "Watch more", id: "WATCH_MORE" },
  { text: "Apply now", id: "APPLY_NOW" },
  { text: "Book now", id: "BOOK_NOW" },
  { text: "Buy tickets", id: "BUY_TICKETS" },
  { text: "Contact us", id: "CONTACT_US" },
]
